import Fab from '@mui/material/Fab';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useGetContactInfoQuery } from '../../store/siteContentApi';

const FALLBACK_WA = '+919014638633';

// Floating WhatsApp CTA — visible on all public pages. Number is admin-editable
// via Settings → Support → Contact Info; we strip non-digits before building
// the wa.me URL so any input format works.
const WhatsAppButton = () => {
  const { data: contact } = useGetContactInfoQuery();
  const raw = contact?.whatsapp || FALLBACK_WA;
  const digits = String(raw).replace(/\D/g, '');
  const href = digits ? `https://wa.me/${digits}` : '#';

  return (
    <Fab
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        bgcolor: '#25D366',
        color: '#fff',
        zIndex: 499,
        boxShadow: '0 4px 20px rgba(37,211,102,0.45)',
        '&:hover': {
          bgcolor: '#1FBF5C',
          transform: 'scale(1.08)',
          boxShadow: '0 8px 28px rgba(37,211,102,0.6)',
        },
      }}
      aria-label="Chat on WhatsApp"
    >
      <WhatsAppIcon />
    </Fab>
  );
};

export default WhatsAppButton;
